/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { GoodsApiModel } from '../api-models/goods';
// @ts-ignore
import { MessageResponseApiModel } from '../api-models/message-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { ClientApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root'
})
export class GoodsApiService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: ClientApiConfiguration
  ) {
    super(basePath, configuration);
  }

  /**
   * Return goods item for terminal
   * @endpoint get /terminal/{terminal_id}/goods
   * @param terminalId Terminal ID
   * @param serviceType Return goods with requested service types. By default return goods without service type.
   * @param onlineStoreAvailableOnly Return only online-store available goods.
   * @param fuelInfo Return fuel info
   * @param priceCustomersAccountInfo Include account customers data in prices
   * @param priceCustomersAccountInfoExtended Include account customers limits data (only if price_customers_account_info is true)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientGetGoodsForTerminal(
    terminalId: string,
    serviceType?: 'none' | 'all' | 'fuel',
    onlineStoreAvailableOnly?: boolean,
    fuelInfo?: boolean,
    priceCustomersAccountInfo?: boolean,
    priceCustomersAccountInfoExtended?: boolean,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<GoodsApiModel>>;
  public incustControllersClientClientGetGoodsForTerminal(
    terminalId: string,
    serviceType?: 'none' | 'all' | 'fuel',
    onlineStoreAvailableOnly?: boolean,
    fuelInfo?: boolean,
    priceCustomersAccountInfo?: boolean,
    priceCustomersAccountInfoExtended?: boolean,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<GoodsApiModel>>>;
  public incustControllersClientClientGetGoodsForTerminal(
    terminalId: string,
    serviceType?: 'none' | 'all' | 'fuel',
    onlineStoreAvailableOnly?: boolean,
    fuelInfo?: boolean,
    priceCustomersAccountInfo?: boolean,
    priceCustomersAccountInfoExtended?: boolean,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<GoodsApiModel>>>;
  public incustControllersClientClientGetGoodsForTerminal(
    terminalId: string,
    serviceType?: 'none' | 'all' | 'fuel',
    onlineStoreAvailableOnly?: boolean,
    fuelInfo?: boolean,
    priceCustomersAccountInfo?: boolean,
    priceCustomersAccountInfoExtended?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (terminalId === null || terminalId === undefined) {
      throw new Error(
        'Required parameter terminalId was null or undefined when calling incustControllersClientClientGetGoodsForTerminal.'
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'service_type',
      <any>serviceType,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'online_store_available_only',
      <any>onlineStoreAvailableOnly,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info',
      <any>fuelInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'price_customers_account_info',
      <any>priceCustomersAccountInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'price_customers_account_info_extended',
      <any>priceCustomersAccountInfoExtended,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/terminal/${this.configuration.encodeParam({
      name: 'terminalId',
      value: terminalId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}/goods`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<GoodsApiModel>>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Return goods item
   * @endpoint get /terminal/{terminal_id}/goods/{code}
   * @param terminalId Terminal ID
   * @param code Good code
   * @param fuelInfo Return fuel info
   * @param priceCustomersAccountInfo Include account customers data in prices
   * @param priceCustomersAccountInfoExtended Include account customers limits data (only if price_customers_account_info is true)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public incustControllersClientClientGetGoodsItem(
    terminalId: string,
    code: string,
    fuelInfo?: boolean,
    priceCustomersAccountInfo?: boolean,
    priceCustomersAccountInfoExtended?: boolean,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<GoodsApiModel>;
  public incustControllersClientClientGetGoodsItem(
    terminalId: string,
    code: string,
    fuelInfo?: boolean,
    priceCustomersAccountInfo?: boolean,
    priceCustomersAccountInfoExtended?: boolean,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<GoodsApiModel>>;
  public incustControllersClientClientGetGoodsItem(
    terminalId: string,
    code: string,
    fuelInfo?: boolean,
    priceCustomersAccountInfo?: boolean,
    priceCustomersAccountInfoExtended?: boolean,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<GoodsApiModel>>;
  public incustControllersClientClientGetGoodsItem(
    terminalId: string,
    code: string,
    fuelInfo?: boolean,
    priceCustomersAccountInfo?: boolean,
    priceCustomersAccountInfoExtended?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (terminalId === null || terminalId === undefined) {
      throw new Error(
        'Required parameter terminalId was null or undefined when calling incustControllersClientClientGetGoodsItem.'
      );
    }
    if (code === null || code === undefined) {
      throw new Error(
        'Required parameter code was null or undefined when calling incustControllersClientClientGetGoodsItem.'
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fuel_info',
      <any>fuelInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'price_customers_account_info',
      <any>priceCustomersAccountInfo,
      QueryParamStyle.Form,
      false
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'price_customers_account_info_extended',
      <any>priceCustomersAccountInfoExtended,
      QueryParamStyle.Form,
      false
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/terminal/${this.configuration.encodeParam({
      name: 'terminalId',
      value: terminalId,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: 'uuid'
    })}/goods/${this.configuration.encodeParam({
      name: 'code',
      value: code,
      in: 'path',
      style: 'simple',
      explode: false,
      dataType: 'string',
      dataFormat: undefined
    })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<GoodsApiModel>(
      'get',
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters.toHttpParams(),
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress
      }
    );
  }
}
